import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../hooks';
import 'mobx-react-lite/batchingForReactDom';
import { SimulcastTable } from '../../../elements';
import Schema, { prepareSchemaProfile } from './schema/';
// import { getTableButtonMethod, getUpdateMemberStateMethod } from './schema/common';
import { memberStatusTypesWithAll, allMemberStatusType  } from '../../../data/memberTypes';
import SelectionFilter from '../SelectionFilter';

const MembersHome = ({ AuctionID, auctionName, laneName, memberType }) => {
  const {
    MembersStore: {
      isLoading,
      data,
      totalItems,
      getMembers,
      updateMemberState,
    },
  } = useStores();

  const [memberStatus, setMemberStatus] = useState(allMemberStatusType);
  const onMemberStatusChange = (value) => setMemberStatus(value);

  const onClearSearch = () => {
    setMemberStatus(allMemberStatusType);
  }

  const schema = Schema(memberType);
  const prepareData = prepareSchemaProfile(schema, {
    auctionId: AuctionID,
    status: memberStatus?.value,
    fn: getMembers,
    memberType,
  });

  const memberStateObject = {
    fn: async (id, enabled, member) =>
      await updateMemberState(id, enabled, member),
    args: ['authorizedMemberID', 'enabled', 'member', 'memberState'],
    callback: (res) => res.reloadData(),
  };

  const tableKey = `${memberStatus.value}`;

  const {
    bodySchema,
    debugging,
    headerSchema,
    initialSortColumn,
    initialSortDirection,
    methods,
    pageSelectTitle,
    searchFields,
  } = prepareData;
  

  return (
    <SimulcastTable
      key={tableKey}
      bodySchema={bodySchema}
      debugging={debugging}
      headerSchema={headerSchema}
      initialMediaState={null}
      initialSortDirection={initialSortDirection}
      initialSortColumn={initialSortColumn}
      isLoading={isLoading}
      methods={methods}
      pageSelectTitle={pageSelectTitle}
      searchFields={searchFields}
      onClearSearch={onClearSearch}
      rowData={data}
      state={{ auctionName, memberState: memberStatus.value, memberStateObject }}
      totalItems={totalItems}
      exportButton={{
        visible: data.length > 0,
        fileName: `MembersReport-${memberType}-${auctionName}`,
        sheetName: `${memberType} Members List`,
        showLocation: ['top'],
      }}
    >
      {schema.tableSettings?.showMemberStatusFilter && (
        <SelectionFilter 
          initialValue={memberStatus}
          options={memberStatusTypesWithAll}
          onChange={onMemberStatusChange}
          title="Status"
        />
      )}
    </SimulcastTable>
  );

  // const [sortColumn, setSortColumn] = useState("Member");
  // const [sortDirection, setSortDirection] = useState("asc");
  // const [pageSize, setPageSize] = useState("50")
  // const [activePage, setActivePage] = useState(1)
  // const [searchText, setSearchText] = useState("")
  // const [showPagination, setShowPagination] = useState(true);
  // const {
  //     MembersStore: {
  //         members,
  //         totalItems,
  //         loadMembers,
  //     }
  // } = useStores();

  // const onSortClick = (column) => {
  //     setSortDirection(sortColumn == column ? (sortDirection == "asc" ? "desc" : "asc") : "asc");
  //     setSortColumn(column);
  //     loadMembers(props.AuctionID, 1, pageSize, searchText, sortColumn, sortDirection, props.memberState)

  // }
  // const onSearch = (searchText) => {
  //     setSearchText(searchText);
  //     loadMembers(props.AuctionID, 1, pageSize, searchText, sortColumn, sortDirection, props.memberState)
  // }
  // const onPageChanged = (e, data) => {

  //     if (data.activePage > 0) {
  //         setActivePage(data.activePage);
  //         loadMembers(props.AuctionID, data.activePage, pageSize, searchText, sortColumn, sortDirection, props.memberState)
  //     }
  // }
  // const onPageSizeChanged = (data, compare) => {
  //     setShowPagination(!compare.match);

  //     setPageSize(data);
  //     loadMembers(props.AuctionID, 1, data, searchText, sortColumn, sortDirection, props.memberState)

  // }
  // useEffect(() => {
  //     loadMembers(props.AuctionID, 1, pageSize, searchText, sortColumn, sortDirection, props.memberState)

  // }, [props.memberState]);
  // useEffect(() => {
  //     // console.log('brian > members', { members: toJS(members), totalItems, pageSize });
  // }, [JSON.stringify(members)], totalItems, pageSize);
  // return (
  //     <React.Fragment>
  //         <Search onSearch={onSearch} title="Registered Member:"></Search>
  //         {/* //TOOD :Haz : move this to shared component */}
  //         <div style={{ fontSize: "0.85em" }}>
  //             <div>
  //                 <div style={{ float: "left", width: "30%", marginBottom: "10px" }}>
  //                     <div style={{ float: "left" }} >Showing {activePage == 1 ? 1 : pageSize * (activePage - 1) + 1}- {activePage * pageSize < totalItems ? activePage * pageSize : totalItems} of {totalItems}
  //                     </div>

  //                 </div>
  //                 <div style={{ float: "right", width: "auto", marginBottom: "10px" }}>
  //                     <div style={{ float: "left", marginTop: "5px" }} >
  //                         <PageSizeSelect pageSize={pageSize} totalItems={totalItems} showPagination={(value) => setShowPagination(value)} onPageSizeChanged={onPageSizeChanged} title="Members" ></PageSizeSelect>
  //                     </div>
  //                     {showPagination && <div style={{ float: "right", marginLeft: "10px" }}>
  //                         <Pagination style={{ fontSize: "1em" }} activePage={activePage} totalPages={Math.ceil(totalItems / pageSize)} onPageChange={onPageChanged} />
  //                     </div>}

  //                 </div>
  //             </div>
  //             <div>

  //                 <MembersList members={toJS(members)} sortColumn={sortColumn} sortDirection={sortDirection} onSortClick={onSortClick}></MembersList>
  //             </div>
  //             <div >
  //                 <div style={{ float: "left", width: "30%", marginTop: "10px" }}>

  //                     <div style={{ float: "left" }} >Showing {activePage == 1 ? 1 : pageSize * (activePage - 1) + 1}- {activePage * pageSize < totalItems ? activePage * pageSize : totalItems} of {totalItems}
  //                     </div>
  //                 </div>
  //                 <div style={{ float: "right", width: "auto", marginTop: "10px" }}>
  //                     <div style={{ float: "left", marginTop: "5px" }}>
  //                         <PageSizeSelect pageSize={pageSize} totalItems={totalItems} showPagination={(value) => setShowPagination(value)} onPageSizeChanged={onPageSizeChanged} title="Members" ></PageSizeSelect>
  //                     </div>

  //                     {showPagination && <div style={{ float: "right", marginLeft: "10px" }}>
  //                         <Pagination style={{ fontSize: "1em" }} activePage={activePage} totalPages={Math.ceil(totalItems / pageSize)} onPageChange={onPageChanged} />
  //                     </div>}
  //                 </div>
  //             </div>
  //         </div >
  //     </React.Fragment >
  // )
};
export default observer(MembersHome);
